/* eslint-disable no-magic-numbers */
import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SessionStorageKeys } from '@constants/common';
import { Routes } from '@constants/routing-permissions';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly router = inject(Router);

  private historyStack: string[] = [];

  constructor() {
    this.loadHistoryFromSession();
  }

  initNavigationTracking() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects;
        const last = this.historyStack[this.historyStack.length - 1];

        if (last !== currentUrl) {
          this.historyStack.push(currentUrl);
          this.saveHistory();
        }
      }
    });
  }

  clearNavigationHistory() {
    this.historyStack = [];
    sessionStorage.removeItem(SessionStorageKeys.navigationHistoryStack);
  }

  private loadHistoryFromSession() {
    const stored = sessionStorage.getItem(
      SessionStorageKeys.navigationHistoryStack
    );
    if (stored) {
      try {
        this.historyStack = JSON.parse(stored);
      } catch {
        this.historyStack = [];
      }
    }
  }

  private saveHistory() {
    sessionStorage.setItem(
      SessionStorageKeys.navigationHistoryStack,
      JSON.stringify(this.historyStack)
    );
  }

  private getPreviousUrl(): string | null {
    if (this.historyStack.length > 1) {
      return this.historyStack[this.historyStack.length - 2];
    }
    return null;
  }

  private popLast() {
    this.historyStack.pop();
    this.saveHistory();
  }

  navigateBack() {
    const prevUrl = this.getPreviousUrl();
    if (prevUrl) {
      this.popLast();
      this.router.navigateByUrl(prevUrl);
    } else {
      this.router.navigate([Routes.PREFIX]);
    }
  }

  navigateToPage(routes: (Routes | number)[]) {
    this.router.navigate(['/', Routes.PREFIX, ...routes]);
  }
}
